<template>
  <ValidationProvider
      class="relative appearance-none w-full TextInput"
      tag="div"
      :vid="vid"
      :rules="rules"
      :name="name"
      v-slot="{ errors, ariaMsg }">
  <input
      :class="{ 'border-gray-300': !errors[0], 'border-red-600': errors[0], 'has-value': hasValue }"
      :id="id"
      :placeholder="placeholder"
      :type="type"
      :value="value"
      :maxlength="maxlength"
      class="w-full py-[11.5px] text-[14px] px-4 border border-gray-300 outline-none focus:border-[#8050CD] focus:rounded-lg rounded-lg"
      v-bind="$attrs"
      @input="onInput"
  />
    <span
        class="block text-red-600 text-xs mt-1"
        v-bind="ariaMsg"
        v-if="errors[0]"
    >{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
export default {
  name: "TextInput",
  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    placeholder: {
      type: String,
      default: null,
    },
    maxlength: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    holder: {
      type: String,
      default: null,
    },
    vid: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text",
      validator(value) {
        return [
          "url",
          "text",
          "password",
          "tel",
          "search",
          "number",
          "email"
        ].includes(value);
      }
    },
    value: {
      type: null,
      default: ""
    }
  },
  computed: {
    hasValue() {
      return !!this.innerValue;
    }
  },
  watch: {
    innerValue(value) {
      this.$emit("input", value);
    },
    value(val) {
      if (val !== this.innerValue) {
        this.innerValue = val;
      }
    }
  },
  methods: {
    onInput({target}) {
      this.$emit('update', target.value)
    },
  },
}
</script>

<style scoped>

</style>